import { useEffect, useState } from 'preact/hooks'
import { EVENT_ACTIONS, EVENT_CATEGORY, OBSERVER_CONFIG } from './analytics.constants'
import { buildLabelObject } from './analytics.utils'

export const useAnalytics = (
    postsNum: number,
    ref: HTMLDivElement,
    embedName: string,
): { onLinkClick: (url: string, index: number) => void } => {
    const [componentPlacement, setComponentPlacement] = useState('')

    useEffect(() => {
        if (postsNum > 0) {
            const article = document.querySelector('article')
            window.mmClientApi = window.mmClientApi || []
            window.mmClientApi.push('analytics', {
                event_category: EVENT_CATEGORY,
                event_action: EVENT_ACTIONS.EMBED,
            })
            if (ref && article) {
                setComponentPlacement((ref.offsetTop / article?.scrollHeight).toFixed(1))
            }
        }
    }, [postsNum])

    useEffect(() => {
        if (ref && postsNum > 0 && componentPlacement && embedName) {
            const ob = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting) {
                    window.mmClientApi = window.mmClientApi || []
                    window.mmClientApi.push('analytics', {
                        event_category: EVENT_CATEGORY,
                        event_action: EVENT_ACTIONS.VIEWABLE,
                        event_label: buildLabelObject(embedName, componentPlacement, postsNum),
                    })
                    ob.disconnect()
                }
            }, OBSERVER_CONFIG)
            ob.observe(ref)
        }
    }, [ref, embedName, componentPlacement, postsNum])

    const onLinkClick = (url: string, index: number) => {
        window.mmClientApi = window.mmClientApi || []
        window.mmClientApi.push('analytics', {
            event_category: EVENT_CATEGORY,
            event_action: EVENT_ACTIONS.CLICK,
            event_label: buildLabelObject(embedName, componentPlacement, postsNum, index + 1, url),
        })
    }

    return { onLinkClick }
}
